
// @ts-nocheck


export const localeCodes =  [
  "de",
  "de_AT",
  "de_DE",
  "de_CH",
  "fr",
  "fr_CH",
  "fr_FR",
  "sv",
  "sv_SE",
  "da",
  "da_DK",
  "nl",
  "nl_NL",
  "en",
  "en_GB",
  "en_US",
  "en_INT"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_de_46ts_984050e8",
      load: () => import("#nuxt-i18n/984050e8" /* webpackChunkName: "locale_de_46ts_984050e8" */),
      cache: false
    }
  ],
  de_AT: [
    {
      key: "locale_de_46ts_984050e8",
      load: () => import("#nuxt-i18n/984050e8" /* webpackChunkName: "locale_de_46ts_984050e8" */),
      cache: false
    },
    {
      key: "locale_de_AT_46ts_8abd6c92",
      load: () => import("#nuxt-i18n/8abd6c92" /* webpackChunkName: "locale_de_AT_46ts_8abd6c92" */),
      cache: true
    }
  ],
  de_DE: [
    {
      key: "locale_de_46ts_984050e8",
      load: () => import("#nuxt-i18n/984050e8" /* webpackChunkName: "locale_de_46ts_984050e8" */),
      cache: false
    },
    {
      key: "locale_de_DE_46ts_143b6551",
      load: () => import("#nuxt-i18n/143b6551" /* webpackChunkName: "locale_de_DE_46ts_143b6551" */),
      cache: true
    }
  ],
  de_CH: [
    {
      key: "locale_de_46ts_984050e8",
      load: () => import("#nuxt-i18n/984050e8" /* webpackChunkName: "locale_de_46ts_984050e8" */),
      cache: false
    },
    {
      key: "locale_de_CH_46ts_6cf165d0",
      load: () => import("#nuxt-i18n/6cf165d0" /* webpackChunkName: "locale_de_CH_46ts_6cf165d0" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46ts_a21082f3",
      load: () => import("#nuxt-i18n/a21082f3" /* webpackChunkName: "locale_fr_46ts_a21082f3" */),
      cache: false
    }
  ],
  fr_CH: [
    {
      key: "locale_fr_46ts_a21082f3",
      load: () => import("#nuxt-i18n/a21082f3" /* webpackChunkName: "locale_fr_46ts_a21082f3" */),
      cache: false
    },
    {
      key: "locale_fr_CH_46ts_441e5922",
      load: () => import("#nuxt-i18n/441e5922" /* webpackChunkName: "locale_fr_CH_46ts_441e5922" */),
      cache: true
    }
  ],
  fr_FR: [
    {
      key: "locale_fr_46ts_a21082f3",
      load: () => import("#nuxt-i18n/a21082f3" /* webpackChunkName: "locale_fr_46ts_a21082f3" */),
      cache: false
    }
  ],
  sv: [
    {
      key: "locale_sv_46ts_c1d87a92",
      load: () => import("#nuxt-i18n/c1d87a92" /* webpackChunkName: "locale_sv_46ts_c1d87a92" */),
      cache: false
    }
  ],
  sv_SE: [
    {
      key: "locale_sv_46ts_c1d87a92",
      load: () => import("#nuxt-i18n/c1d87a92" /* webpackChunkName: "locale_sv_46ts_c1d87a92" */),
      cache: false
    }
  ],
  da: [
    {
      key: "locale_da_46ts_5f94be89",
      load: () => import("#nuxt-i18n/5f94be89" /* webpackChunkName: "locale_da_46ts_5f94be89" */),
      cache: false
    }
  ],
  da_DK: [
    {
      key: "locale_da_46ts_5f94be89",
      load: () => import("#nuxt-i18n/5f94be89" /* webpackChunkName: "locale_da_46ts_5f94be89" */),
      cache: false
    }
  ],
  nl: [
    {
      key: "locale_nl_46ts_9ea364aa",
      load: () => import("#nuxt-i18n/9ea364aa" /* webpackChunkName: "locale_nl_46ts_9ea364aa" */),
      cache: false
    }
  ],
  nl_NL: [
    {
      key: "locale_nl_46ts_9ea364aa",
      load: () => import("#nuxt-i18n/9ea364aa" /* webpackChunkName: "locale_nl_46ts_9ea364aa" */),
      cache: false
    }
  ],
  en: [
    {
      key: "locale_en_46ts_6699b0bd",
      load: () => import("#nuxt-i18n/6699b0bd" /* webpackChunkName: "locale_en_46ts_6699b0bd" */),
      cache: false
    }
  ],
  en_GB: [
    {
      key: "locale_en_46ts_6699b0bd",
      load: () => import("#nuxt-i18n/6699b0bd" /* webpackChunkName: "locale_en_46ts_6699b0bd" */),
      cache: false
    },
    {
      key: "locale_en_GB_46ts_65240b48",
      load: () => import("#nuxt-i18n/65240b48" /* webpackChunkName: "locale_en_GB_46ts_65240b48" */),
      cache: true
    }
  ],
  en_US: [
    {
      key: "locale_en_46ts_6699b0bd",
      load: () => import("#nuxt-i18n/6699b0bd" /* webpackChunkName: "locale_en_46ts_6699b0bd" */),
      cache: false
    },
    {
      key: "locale_en_US_46ts_03b34efb",
      load: () => import("#nuxt-i18n/03b34efb" /* webpackChunkName: "locale_en_US_46ts_03b34efb" */),
      cache: true
    }
  ],
  en_INT: [
    {
      key: "locale_en_46ts_6699b0bd",
      load: () => import("#nuxt-i18n/6699b0bd" /* webpackChunkName: "locale_en_46ts_6699b0bd" */),
      cache: false
    },
    {
      key: "locale_en_INT_46ts_20776aa2",
      load: () => import("#nuxt-i18n/20776aa2" /* webpackChunkName: "locale_en_INT_46ts_20776aa2" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/a897387c" /* webpackChunkName: "config_i18n_46config_46ts_a897387c" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de",
      iso: "de",
      files: [
        {
          path: "/usr/src/app/i18n/locales/de.ts",
          cache: undefined
        }
      ],
      name: "Deutsch"
    },
    {
      code: "de_AT",
      countryISO2: "at",
      iso: "de-at",
      files: [
        {
          path: "/usr/src/app/i18n/locales/de.ts",
          cache: undefined
        },
        {
          path: "/usr/src/app/i18n/locales/de_AT.ts",
          cache: undefined
        }
      ],
      name: "Österreich"
    },
    {
      code: "de_DE",
      countryISO2: "de",
      iso: "de-de",
      files: [
        {
          path: "/usr/src/app/i18n/locales/de.ts",
          cache: undefined
        },
        {
          path: "/usr/src/app/i18n/locales/de_DE.ts",
          cache: undefined
        }
      ],
      name: "Deutschland"
    },
    {
      code: "de_CH",
      countryISO2: "ch",
      iso: "de-ch",
      files: [
        {
          path: "/usr/src/app/i18n/locales/de.ts",
          cache: undefined
        },
        {
          path: "/usr/src/app/i18n/locales/de_CH.ts",
          cache: undefined
        }
      ],
      name: "Schweiz"
    },
    {
      code: "fr",
      iso: "fr",
      files: [
        {
          path: "/usr/src/app/i18n/locales/fr.ts",
          cache: undefined
        }
      ],
      name: "French"
    },
    {
      code: "fr_CH",
      countryISO2: "ch",
      iso: "fr-ch",
      files: [
        {
          path: "/usr/src/app/i18n/locales/fr.ts",
          cache: undefined
        },
        {
          path: "/usr/src/app/i18n/locales/fr_CH.ts",
          cache: undefined
        }
      ],
      name: "Suisse"
    },
    {
      code: "fr_FR",
      countryISO2: "fr",
      iso: "fr-fr",
      files: [
        {
          path: "/usr/src/app/i18n/locales/fr.ts",
          cache: undefined
        }
      ],
      name: "France"
    },
    {
      code: "sv",
      iso: "sv",
      files: [
        {
          path: "/usr/src/app/i18n/locales/sv.ts",
          cache: undefined
        }
      ],
      name: "Sweden"
    },
    {
      code: "sv_SE",
      countryISO2: "se",
      iso: "sv",
      files: [
        {
          path: "/usr/src/app/i18n/locales/sv.ts",
          cache: undefined
        }
      ],
      name: "Sweden"
    },
    {
      code: "da",
      iso: "da",
      files: [
        {
          path: "/usr/src/app/i18n/locales/da.ts",
          cache: undefined
        }
      ],
      name: "Denmark"
    },
    {
      code: "da_DK",
      countryISO2: "dk",
      iso: "da",
      files: [
        {
          path: "/usr/src/app/i18n/locales/da.ts",
          cache: undefined
        }
      ],
      name: "Denmark"
    },
    {
      code: "nl",
      iso: "nl",
      files: [
        {
          path: "/usr/src/app/i18n/locales/nl.ts",
          cache: undefined
        }
      ],
      name: "Netherlands"
    },
    {
      code: "nl_NL",
      countryISO2: "nl",
      iso: "nl",
      files: [
        {
          path: "/usr/src/app/i18n/locales/nl.ts",
          cache: undefined
        }
      ],
      name: "Netherlands"
    },
    {
      code: "en",
      files: [
        {
          path: "/usr/src/app/i18n/locales/en.ts",
          cache: undefined
        }
      ],
      name: "English"
    },
    {
      code: "en_GB",
      countryISO2: "gb",
      iso: "en-gb",
      files: [
        {
          path: "/usr/src/app/i18n/locales/en.ts",
          cache: undefined
        },
        {
          path: "/usr/src/app/i18n/locales/en_GB.ts",
          cache: undefined
        }
      ],
      name: "United Kingdom"
    },
    {
      code: "en_US",
      countryISO2: "us",
      iso: "en-us",
      files: [
        {
          path: "/usr/src/app/i18n/locales/en.ts",
          cache: undefined
        },
        {
          path: "/usr/src/app/i18n/locales/en_US.ts",
          cache: undefined
        }
      ],
      name: "United States"
    },
    {
      code: "en_INT",
      countryISO2: "ie",
      iso: "en",
      files: [
        {
          path: "/usr/src/app/i18n/locales/en.ts",
          cache: undefined
        },
        {
          path: "/usr/src/app/i18n/locales/en_INT.ts",
          cache: undefined
        }
      ],
      name: "International"
    }
  ],
  defaultLocale: "en_INT",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de",
    iso: "de",
    files: [
      {
        path: "/usr/src/app/i18n/locales/de.ts",
        cache: undefined
      }
    ],
    name: "Deutsch"
  },
  {
    code: "de_AT",
    countryISO2: "at",
    iso: "de-at",
    files: [
      {
        path: "/usr/src/app/i18n/locales/de.ts",
        cache: undefined
      },
      {
        path: "/usr/src/app/i18n/locales/de_AT.ts",
        cache: undefined
      }
    ],
    name: "Österreich"
  },
  {
    code: "de_DE",
    countryISO2: "de",
    iso: "de-de",
    files: [
      {
        path: "/usr/src/app/i18n/locales/de.ts",
        cache: undefined
      },
      {
        path: "/usr/src/app/i18n/locales/de_DE.ts",
        cache: undefined
      }
    ],
    name: "Deutschland"
  },
  {
    code: "de_CH",
    countryISO2: "ch",
    iso: "de-ch",
    files: [
      {
        path: "/usr/src/app/i18n/locales/de.ts",
        cache: undefined
      },
      {
        path: "/usr/src/app/i18n/locales/de_CH.ts",
        cache: undefined
      }
    ],
    name: "Schweiz"
  },
  {
    code: "fr",
    iso: "fr",
    files: [
      {
        path: "/usr/src/app/i18n/locales/fr.ts",
        cache: undefined
      }
    ],
    name: "French"
  },
  {
    code: "fr_CH",
    countryISO2: "ch",
    iso: "fr-ch",
    files: [
      {
        path: "/usr/src/app/i18n/locales/fr.ts",
        cache: undefined
      },
      {
        path: "/usr/src/app/i18n/locales/fr_CH.ts",
        cache: undefined
      }
    ],
    name: "Suisse"
  },
  {
    code: "fr_FR",
    countryISO2: "fr",
    iso: "fr-fr",
    files: [
      {
        path: "/usr/src/app/i18n/locales/fr.ts",
        cache: undefined
      }
    ],
    name: "France"
  },
  {
    code: "sv",
    iso: "sv",
    files: [
      {
        path: "/usr/src/app/i18n/locales/sv.ts",
        cache: undefined
      }
    ],
    name: "Sweden"
  },
  {
    code: "sv_SE",
    countryISO2: "se",
    iso: "sv",
    files: [
      {
        path: "/usr/src/app/i18n/locales/sv.ts",
        cache: undefined
      }
    ],
    name: "Sweden"
  },
  {
    code: "da",
    iso: "da",
    files: [
      {
        path: "/usr/src/app/i18n/locales/da.ts",
        cache: undefined
      }
    ],
    name: "Denmark"
  },
  {
    code: "da_DK",
    countryISO2: "dk",
    iso: "da",
    files: [
      {
        path: "/usr/src/app/i18n/locales/da.ts",
        cache: undefined
      }
    ],
    name: "Denmark"
  },
  {
    code: "nl",
    iso: "nl",
    files: [
      {
        path: "/usr/src/app/i18n/locales/nl.ts",
        cache: undefined
      }
    ],
    name: "Netherlands"
  },
  {
    code: "nl_NL",
    countryISO2: "nl",
    iso: "nl",
    files: [
      {
        path: "/usr/src/app/i18n/locales/nl.ts",
        cache: undefined
      }
    ],
    name: "Netherlands"
  },
  {
    code: "en",
    files: [
      {
        path: "/usr/src/app/i18n/locales/en.ts",
        cache: undefined
      }
    ],
    name: "English"
  },
  {
    code: "en_GB",
    countryISO2: "gb",
    iso: "en-gb",
    files: [
      {
        path: "/usr/src/app/i18n/locales/en.ts",
        cache: undefined
      },
      {
        path: "/usr/src/app/i18n/locales/en_GB.ts",
        cache: undefined
      }
    ],
    name: "United Kingdom"
  },
  {
    code: "en_US",
    countryISO2: "us",
    iso: "en-us",
    files: [
      {
        path: "/usr/src/app/i18n/locales/en.ts",
        cache: undefined
      },
      {
        path: "/usr/src/app/i18n/locales/en_US.ts",
        cache: undefined
      }
    ],
    name: "United States"
  },
  {
    code: "en_INT",
    countryISO2: "ie",
    iso: "en",
    files: [
      {
        path: "/usr/src/app/i18n/locales/en.ts",
        cache: undefined
      },
      {
        path: "/usr/src/app/i18n/locales/en_INT.ts",
        cache: undefined
      }
    ],
    name: "International"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/